<template>
    <main class="fill-blank" :class="{ 'active-require': showRequire }" :id="id">
        <!-- <h5 class="stem">
            问题 
			<span>{{ current }}</span>
			<span class="sub">/ {{ all }}</span>
        </h5> -->
        <div class="stem-title">
            <span class="index">{{ current }}. </span>
            <p class="title" :ref="id" v-html="title"></p>
        </div>
        <p class="desc" v-html="desc"></p>
        <div class="field-wrap" :class="{ active: isFocus || inputValue }">
            <van-field
                @focus="handleFocus"
                @blur="isFocus = false"
                rows="2"
                style="
					background-color: transparent;
					padding: 10px;
				"
                :autosize="{ minHeight: 80 }"
                type="textarea"
                show-word-limit
                maxlength="200"
                :placeholder="placeholder"
                v-model="inputValue"
                @input="handleInputChange"
            />
        </div>
        <div v-if="isCanUploadImageByQuestion">
            <p class="upload-image">请上传图片</p>
            <van-uploader
                v-if="!isInApp"
                v-model="fileList"
                accept="image/*"
                :capture="false"
                :max-count="maxCount"
                :max-size="5 * 1024 * 1024"
                :before-read="beforeRead"
                :after-read="handleAfterRead"
                @oversize="handleOversize"
                @delete="handleDeleteImage"
            />
            <div
                v-else
                style="display: flex; justify-content: flex-start; gap: 6px; flex-wrap: wrap;"
            >
                <div v-for="item in fileList" style="position: relative;" :key="item.url">
                    <img
                        class="close"
                        style="width: 20px; height: 20px;"
                        src="../../assets/images/close.png"
                        alt=""
                        @click="handleDeleteImage(item)"
                    />
                    <img :src="item.url" style="width: 80px; height: 80px;" />
                </div>
                <div class="upload-image-btn" @click="handleApplyImage"></div>
            </div>
            <!-- <div
                style="margin-top: 50px; font-size: 12px; overflow: hidden; white-space: wrap;"
                @click="copyDivContent"
            >
                {{ base64Str }}
            </div> -->
        </div>
        <div v-if="showRequire" class="require-tip">此题为必填项，请完成</div>
    </main>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { ImagePreview, Toast, Dialog } from 'vant';
import { QuestionRequire } from '@/libs/enum';
import { imageUrl } from '@/libs/tool';
import { DB_ON_QUESTIONNAIR } from '@/libs/constant';
import { uploadImage, deleteImage, uploadImage1 } from '@/apis';
import { Permissions, Upload, PushNotification } from '@/libs/invoke';
import browser from '@/libs/browser';

export default {
    name: 'fill-blank',
    props: {
        value: {
            type: String,
            default: ''
        },
        title: {
            type: String,
            default: null
        },
        desc: {
            type: String,
            default: null
        },
        all: {
            type: Number,
            default: 0
        },
        current: {
            type: Number,
            default: 0
        },
        require: {
            // 0 非必填; 1 必填。默认非必填
            type: String,
            default: () => QuestionRequire.no
        },
        id: {
            type: String,
            default: () => '',
            require: true
        },
        question: {
            type: Object,
            default: () => ({})
        }
    },
    computed: {
        ...mapState(['passValidate', 'questionnaireCode']),
        ...mapGetters(['isCanUploadImage']),
        showRequire() {
            if (
                this.passValidate &&
                this.passValidate.qidentifier &&
                this.require === QuestionRequire.yes &&
                !this.inputValue
            ) {
                return true;
            }
            return false;
        },
        placeholder() {
            return this.question.placeholder || '请简述内容';
        },
        maxCount() {
            return this.question.maxCount || 4;
        },
        isCanUploadImageByQuestion() {
            return this.isCanUploadImage && this.question.enablePicUpload === '1';
        },
        isInApp() {
            return browser.isApp();
        }
    },
    watch: {
        value(n) {
            this.inputValue = n;
        },
        fileList: {
            handler(list = []) {
                const successFileList = list.filter(item => item.status === 'done');
                this.question.fileUrls = successFileList.map(item => item.url);
            },
            deep: true
        }
    },
    data() {
        let fileList = [];
        if (this.question.fileUrls) {
            fileList = this.question.fileUrls.map(url => ({ url }));
        }
        return {
            isFocus: false,
            inputValue: this.value,
            fileList,
            base64Str: ''
        };
    },
    methods: {
        copyDivContent() {
            // 1. 创建一个临时的 textarea 元素
            const textarea = document.createElement('textarea');
            textarea.value = this.base64Str;

            // 2. 隐藏 textarea 并添加到 DOM
            textarea.style.position = 'fixed';
            document.body.appendChild(textarea);

            // 3. 选中并执行拷贝
            textarea.select();
            document.execCommand('copy');

            // 4. 移除临时元素
            document.body.removeChild(textarea);

            alert('已拷贝');
        },
        handleInputChange(text) {
            this.$emit('input', text);
            this.$emit('on-change', text);
        },
        handleFocus() {
            this.isFocus = true;
            this.$track(DB_ON_QUESTIONNAIR);
        },
        handleTitleImage(imageUrl) {
            if (imageUrl) {
                ImagePreview({
                    images: [imageUrl],
                    closeable: true
                });
            }
        },
        uploadFile(file) {
            file.message = '上传中';
            file.status = 'uploading';
            uploadImage(file.file, {
                qidentifier: this.question.qidentifier,
                questionnaireCode: this.questionnaireCode
            })
                .then(res => {
                    const { data } = res;
                    console.log('====>>> ', res);
                    if (!data.success) {
                        this.$toast({ message: data.message || '图片上传失败' });
                        file.status = 'failed';
                        file.message = '上传失败';
                    } else {
                        file.status = 'done';
                        file.message = '上传完成';
                        // https://quiz-activity-test.eastmoney.com/questionnaire/api/questionnaire/resource/axTZNW?fileCode=1624319249179709440.jpg
                        console.log('===>>> ', imageUrl(data.data.picCode));
                        file.url = imageUrl(data.data.picCode);
                    }
                })
                .catch(() => {
                    file.status = 'failed';
                    file.message = '上传失败';
                    const findIndex = this.fileList.findIndex(item => {
                        if (!item.file) {
                            return false;
                        }
                        if (item.file.lastModified === file.file.lastModified) {
                            return true;
                        }
                        return false;
                    });
                    if (findIndex > -1) {
                        this.fileList.splice(findIndex, 1);
                    }
                    this.$toast('网络不佳，上传失败');
                });
        },
        handleAfterRead(files) {
            if (Array.isArray(files)) {
                files.map(file => this.uploadFile(file));
            } else {
                const file = files;
                this.uploadFile(file);
            }
        },
        handleDeleteImage(file) {
            if (!file || !file.url) {
                return;
            }
            const url = new URL(file.url);
            const fileCode = url.searchParams.get('fileCode');
            if (fileCode) {
                deleteImage({
                    questionnaireCode: this.questionnaireCode,
                    qIdentifier: this.question.qidentifier,
                    fileCode
                }).then(result => {
                    const { data } = result;
                    if (data && data.success) {
                        this.$toast({ message: '删除成功' });
                    }
                    if (this.isInApp) {
                        const idx = this.fileList.findIndex(item => item.url.includes(fileCode));
                        this.fileList.splice(idx, 1);
                    }
                });
            }
        },
        handleOversize() {
            Toast('您的图片过大，文件大小不能超过5M');
        },
        beforeRead(files) {
            console.log('===>>> ', files);
            const fileTypes = ['image/jpeg', 'image/png'];
            if (Array.isArray(files) && files.length) {
                const filterFiles = files.filter(file => !fileTypes.includes(file.type));
                if (filterFiles && filterFiles.length) {
                    Toast('请上传 jpeg|jpg|png 格式图片');
                    return;
                }
            } else {
                const file = files;
                console.log('====>>> ', file.size);
                if (!fileTypes.includes(file.type)) {
                    Toast('请上传 jpeg|jpg|png 格式图片');
                    return false;
                }
            }
            return true;
        },
        base64ToFile(pureBase64, filename, mimeType) {
            // ===== 1. 参数校验 =====
            if (typeof pureBase64 !== 'string' || !pureBase64) {
                throw new Error('Base64字符串不能为空');
            }

            // ===== 2. 自动推断MIME类型 =====
            const mimeMap = {
                png: 'image/png',
                jpg: 'image/jpeg',
                jpeg: 'image/jpeg',
                gif: 'image/gif',
                webp: 'image/webp',
                svg: 'image/svg+xml',
                pdf: 'application/pdf',
                txt: 'text/plain'
            };

            const fileExt = filename
                .split('.')
                .pop()
                .toLowerCase();
            const inferredType = mimeType || mimeMap[fileExt] || 'application/octet-stream';

            // ===== 3. Base64解码 =====
            try {
                const byteString = atob(pureBase64);
                const byteArray = new Uint8Array(byteString.length);

                for (let i = 0; i < byteString.length; i++) {
                    byteArray[i] = byteString.charCodeAt(i);
                }

                // ===== 4. 创建File/Blob对象 =====
                if (typeof File !== 'undefined') {
                    return new File([byteArray], filename, {
                        type: inferredType,
                        lastModified: Date.now()
                    });
                }

                // 兼容旧浏览器（返回Blob）
                const blob = new Blob([byteArray], { type: inferredType });
                blob.name = filename; // 模拟File属性
                return blob;
            } catch (e) {
                throw new Error(`Base64转换失败: ${e.message}`);
            }
        },
        async handleApplyImage() {
            let status;
            if (browser.isAndroid()) {
                status = await Permissions.getPermissionStatus(
                    'android.permission.READ_MEDIA_IMAGES'
                );
            } else if (browser.isIOS()) {
                status = await Permissions.getPermissionStatus('photo');
            }
            if (status && status === 'authorized') {
                try {
                    const imageData = await Upload.openLocalGallery({ reqBase64: true });
                    const base64 = imageData.base64;
                    this.base64Str = imageData.base64;
                    // const file = this.base64ToFile(base64, Date.now() + '.jpg', 'image/jpeg');
                    const toast = Toast.loading({
                        duration: 0, // 持续展示 toast
                        forbidClick: true,
                        message: '图片上传中...'
                    });
                    const res = await uploadImage1(base64, {
                        qidentifier: this.question.qidentifier,
                        questionnaireCode: this.questionnaireCode
                    });
                    toast.clear();
                    const { data } = res;
                    if (!data.success) {
                        this.$toast({ message: data.message || '图片上传失败' });
                    } else {
                        // https://quiz-activity-test.eastmoney.com/questionnaire/api/questionnaire/resource/axTZNW?fileCode=1624319249179709440.jpg
                        const imgUrl = imageUrl(data.data.picCode);
                        console.log(imgUrl);
                        const t = setTimeout(() => {
                            this.fileList.push({ url: imgUrl, status: 'done' });
                            clearTimeout(t);
                        }, 200);
                    }
                } catch (error) {
                    console.error(error);
                    this.$toast('图片获取或上传失败');
                }
            } else {
                Dialog.confirm({
                    title: '存储权限（图片）获取说明',
                    message:
                        '用于您在问卷调查过程中需要使用图片完成问卷，所以需要图片获取权限，拒绝或取消授权下不影响使用其他服务。'
                })
                    .then(async () => {
                        if (browser.isAndroid()) {
                            Permissions.request('android.permission.READ_MEDIA_IMAGES').catch(
                                () => {
                                    PushNotification.requestPermissions();
                                }
                            );
                        } else if (browser.isIOS()) {
                            Permissions.request('photo').catch(() => {
                                PushNotification.requestPermissions();
                            });
                        }
                    })
                    .catch(() => {});
            }
        }
    },
    mounted() {
        // 由于标题，图片是富文本动态渲染进去的，使用原生dom去进行查询访问
        const ref = this.$refs[this.id];
        if (ref) {
            ref.addEventListener(
                'click',
                e => {
                    this.handleTitleImage(e.target.src);
                },
                false
            );
        }
    }
};
</script>
<style lang="scss" scoped>
.fill-blank {
    padding: 30px 40px;
    margin: 32px 32px;
    background-color: #fff;
    border-radius: 12px;
    margin-bottom: 32px;
    box-shadow: 0 8px 60px 10px rgba(46, 39, 39, 0.11);
    .stem {
        font-size: 32px;
        color: #ff530d;
        .sub {
            font-size: 26px;
        }
    }
    .stem-title {
        display: flex;
        font-size: 32px;
        .index {
            display: inline-block;
            padding-top: 22px;
            padding-right: 10px;
        }
    }
    .title {
        font-size: 36px;
        color: #333333;
        padding: 20px 0px;
        word-break: break-all;
    }
    .desc {
        font-size: 28px;
        color: #999999;
        padding-bottom: 20px;
        word-break: break-all;
    }
    .field-wrap {
        border: solid 2px rgba(0, 0, 0, 0.08);
        border-radius: 16px;
        margin-bottom: 20px;
        transition: 0.2s;
    }
    .field-wrap.active {
        border: 2px solid rgba(255, 85, 0, 0.2);
        background: rgba(255, 85, 0, 0.04);
    }
    /deep/ textarea {
        caret-color: #ff530d;
    }
    .require-tip {
        background-color: #ffe5e0;
        color: red;
        font-size: 28px;
        padding: 15px 0 15px 30px;
        text-align: left;
        border-radius: 5px;
    }
    .upload-image {
        font-size: 26px;
        margin-bottom: 10px;
    }
    .upload-image-btn {
        width: 160px;
        height: 160px;
        background-image: url('../../assets/images/xiangji.png');
        background-size: 160px 160px;
    }
    .close {
        position: absolute;
        top: 0px;
        right: 0;
        width: 20px;
        height: 20px;
    }
}
.active-require {
    border: dashed 2px red;
}
</style>
<style lang="scss">
.stem-title .title img {
    max-width: 100%;
    height: auto;
}
</style>
